import React from 'react';
import MDBox from '../MDBox';

const Popup = (props) => {
	if (!props.open) {
		return null
	}
	return <> <MDBox position="fixed" bgColor="#bdc3c740" right={0} top={0} display="flex" justifyContent="center" alignItems="center" zIndex={9999} width="100%" height="100vh">

			<MDBox color="dark" bgColor="white" variant="contained" borderRadius="lg" shadow="lg" opacity={1} p={2} 
			width="90%" {...props}/>

		</MDBox>
	</>;

}

export default Popup